var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar"
  }, [_c('router-link', {
    staticClass: "navbar__brand logo",
    attrs: {
      "to": "/",
      "tag": "a"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/logo.png",
      "alt": "Bimbi"
    }
  })]), _vm._v(" "), _c('nav', {
    staticClass: "navbar__navigation navigation"
  }, [_c('ul', {
    staticClass: "navigation__list"
  }, [_c('li', {
    staticClass: "navigation__item navigation__item--first"
  }, [_c('router-link', {
    staticClass: "navigation__link navigation__link--hover",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Начало")])], 1), _vm._v(" "), _c('li', {
    staticClass: "navigation__item"
  }, [_c('router-link', {
    staticClass: "navigation__link navigation__link--hover2",
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Продукти")]), _vm._v(" "), _c('ul', _vm._l((_vm.products), function(product) {
    return _c('li', {
      key: product.id,
      on: {
        "click": function($event) {
          _vm.changeRoute(product.slug, product.id)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": '/product/' + product.slug + '/' + product.id
      },
      domProps: {
        "textContent": _vm._s(product.title)
      }
    })], 1)
  }))], 1), _vm._v(" "), _c('li', {
    staticClass: "navigation__item"
  }, [_c('router-link', {
    staticClass: "navigation__link navigation__link--hover3",
    attrs: {
      "to": "/contacts"
    }
  }, [_vm._v("Контакти")])], 1), _vm._v(" "), _c('li', {
    staticClass: "navigation__item"
  }, [_c('a', {
    staticClass: "navigation__link navigation__link--social",
    attrs: {
      "href": _vm.facebook,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/social-facebook-icon.png",
      "alt": "Facebook"
    }
  })])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73cfdccf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/Navbar.vue
// module id = NQWz
// module chunks = 1